import React, { FC } from 'react'
import { FormItemProps, InputProps as AntdInputProps } from 'formik-antd'
import { FormItem, Input as AntInput } from '@src/helpers/Formik/formikAntdCompat'
import { useTranslation } from 'react-i18next'
import { HelpTextWrapper } from '@src/components/Desktop/Containers/Input/Input.styles'

interface InputProps extends Omit<AntdInputProps, 'name'>, Pick<FormItemProps, 'label' | 'name'> {
  helpText?: string
  placeholder?: string
  required?: boolean
  type: string
}

export const Input: FC<InputProps> = ({ label, helpText, name, placeholder, required, ...props }) => {
  const { t } = useTranslation()

  return (
    <FormItem labelCol={{ span: 24 }} label={label} name={name} required={required}>
      <AntInput {...props} placeholder={placeholder || t('forms.validation.info.noValueSet')} name={name} />
      {helpText && (
        <HelpTextWrapper>
          <label htmlFor={name}>{helpText}</label>
        </HelpTextWrapper>
      )}
    </FormItem>
  )
}
